angular.module('unica_invitation_room.invitation_room_services')

.factory('InvitationRoomListService', function ($http, getBaseApiURL) {

	var invitationRoomListService = {};

	invitationRoomListService.list = function (eventId, limit, offset) {
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/invitation-room/list/' + eventId,
			data: {
				limit: limit,
				offset: offset,
			}
		}).then(function(result) {

			if ( result ) {
				return result.data.invitation_rooms;
			}

		});

	};

	invitationRoomListService.get = function (invitationRoomId) {
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/invitation-room/detail/' + invitationRoomId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return result.data.invitation_room;
			}

		});

	};

	invitationRoomListService.search = function (eventId, term)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/invitation-room/search/' + eventId,
			data: {
				search: term
			}
		}).then(function(result) {

			if ( result ) {
				return result.data.invitation_rooms;
			}

		});
	};

	invitationRoomListService.exportRoomEvent = function (eventId) {
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/export/invitation-room/' + eventId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return result.data.url;
			}

		});
	};


	return invitationRoomListService;
});